import { AudienceParcoursStubPage } from '../../../../components/parcours/AudienceParcoursStubPage';
import { getOperationIndustrieStub } from '../../../../config/operations-industrie';

export default function AuditReglementairePage() {
  const parcours = getOperationIndustrieStub('audit-reglementaire');
  if (!parcours) return null;
  return (
    <AudienceParcoursStubPage
      parcours={parcours}
      audienceId="industrie"
      segment="operations"
      segmentLabel="Utilités & process"
      crossLinks={[
        {
          label: 'ISO 50001',
          href: '/industrie/iso-50001',
          iconName: 'shield-check',
          hint: "Démarche dispensant de l'audit obligatoire",
        },
        {
          label: 'CEE IND',
          href: '/industrie/aides/cee-ind',
          iconName: 'sparkles',
          hint: 'Financer les actions issues des préconisations audit',
        },
        {
          label: 'Fonds décarbonation industrie',
          href: '/industrie/aides/fonds-decarbonation',
          iconName: 'banknote',
          hint: 'Pour les projets structurants identifiés par l’audit',
        },
      ]}
      crossLinksAllLabel="Toutes les aides industrie"
      crossLinksAllHref="/industrie/aides"
    />
  );
}
